export default {
	// 获取图片
	$img(path, local) {
		if (path) {
			if (path.substring(0, 4) == 'http') {
				return path;
			} else {
				return $config.apihost + '/' + path;
			}
		} else {
			return '';
		}
	},
	$navto(url) {
		this.$router.push(url);
	},
	$back() {
		this.$router.go(-1);
	},
	$warning(msg) {
		this.$message({
			message: msg,
			type: 'warning'
		});
	},
	$success(msg) {
		this.$message({
			message: msg,
			type: 'success'
		});
	},
	$load(flag) {
		if (!flag) {
			this.$loading().close();
		} else {
			this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading'
			});
		}
	},
	$getCurrentTime(format = 'YYYY-MM-DD HH:mm:ss') {
		const now = new Date();
		const year = now.getFullYear();
		const month = now.getMonth() + 1;
		const day = now.getDate();
		const hours = now.getHours();
		const minutes = now.getMinutes();
		const seconds = now.getSeconds();
		const week = now.getDay();
		const formatMap = {
			// 年份
			'YYYY': year,
			'YY': String(year).slice(-2),
			// 月份
			'MM': String(month).padStart(2, '0'),
			'M': month,
			// 日期
			'DD': String(day).padStart(2, '0'),
			'D': day,
			// 小时
			'HH': String(hours).padStart(2, '0'),
			'H': hours,
			'hh': String(hours % 12 || 12).padStart(2, '0'),
			'h': hours % 12 || 12,
			// 分钟
			'mm': String(minutes).padStart(2, '0'),
			'm': minutes,
			// 秒
			'ss': String(seconds).padStart(2, '0'),
			's': seconds,
			// 星期
			'WW': ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][week],
			'W': ['日', '一', '二', '三', '四', '五', '六'][week],
			// 上午/下午
			'A': hours < 12 ? '上午' : '下午',
			'a': hours < 12 ? 'AM' : 'PM'
		};
		return format.replace(/YYYY|YY|MM|M|DD|D|HH|H|hh|h|mm|m|ss|s|WW|W|A|a/g, match => formatMap[match]);
	},
	$formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
		if (!date) return '';
		const d = new Date(date);
		const year = d.getFullYear();
		const month = d.getMonth() + 1;
		const day = d.getDate();
		const hours = d.getHours();
		const minutes = d.getMinutes();
		const seconds = d.getSeconds();
		const week = d.getDay();
		const formatMap = {
			// 年份
			'YYYY': year,
			'YY': String(year).slice(-2),
			// 月份
			'MM': String(month).padStart(2, '0'),
			'M': month,
			// 日期
			'DD': String(day).padStart(2, '0'),
			'D': day,
			// 小时
			'HH': String(hours).padStart(2, '0'),
			'H': hours,
			'hh': String(hours % 12 || 12).padStart(2, '0'),
			'h': hours % 12 || 12,
			// 分钟
			'mm': String(minutes).padStart(2, '0'),
			'm': minutes,
			// 秒
			'ss': String(seconds).padStart(2, '0'),
			's': seconds,
			// 星期
			'WW': ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][week],
			'W': ['日', '一', '二', '三', '四', '五', '六'][week],
			// 上午/下午
			'A': hours < 12 ? '上午' : '下午',
			'a': hours < 12 ? 'AM' : 'PM'
		};
		return format.replace(/YYYY|YY|MM|M|DD|D|HH|H|hh|h|mm|m|ss|s|WW|W|A|a/g, match => formatMap[match]);
	},
	multiply(a, b) {
		// 确保输入是数字
		const num1 = parseFloat(a) || 0;
		const num2 = parseFloat(b) || 0;
		const result = num1 * num2;
		// 直接返回字符串格式，保留两位小数
		return result.toFixed(2);
	},
}